import { api } from '@/lib/api';
import { queryOptions } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';

export interface Clinic {
  id: number;
  name: string;
  created_at?: string;
  updated_at?: string;
}

export interface PaginationMeta {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

export interface ClinicsResponse {
  data: Array<Clinic>;
  links?: {
    first?: string | null;
    last?: string | null;
    prev?: string | null;
    next?: string | null;
  };
  meta: PaginationMeta;
}

export const getClinicsQuery = (page: number = 1) =>
  queryOptions({
    queryKey: queryKeys.clinics.all(page),
    queryFn: async (): Promise<ClinicsResponse> => {
      return await api
        .get('clinics', { searchParams: { page } })
        .json<ClinicsResponse>();
    },
  });

export const getAllClinicsQuery = (perPage: number = 500) =>
  queryOptions({
    queryKey: [...queryKeys.clinics.all(), 'all', perPage],
    queryFn: async (): Promise<Array<Clinic>> => {
      const response = await api
        .get('clinics', { searchParams: { per_page: perPage } })
        .json<ClinicsResponse>();
      return response.data;
    },
  });
